export var FormContainerBreakpoints = {
    '2': 760,
    '3': 1152,
};
